/**
 * Resuelve el host base del API.
 * En local, si el front corre en :3000 y REACT_APP_API_URL apunta a :8080,
 * usamos el mismo origen del navegador para que CRA proxy reenvíe a Spring
 * (evita CORS en /api/python, que no tiene @CrossOrigin en el backend).
 */
export const resolveApiRoot = () => {
  const configured = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");

  if (typeof window !== "undefined" && configured) {
    const sameHostDifferentPort =
      window.location.hostname === "localhost" &&
      configured.includes("localhost:8080") &&
      window.location.origin !== configured;

    if (sameHostDifferentPort) {
      return window.location.origin;
    }
  }

  return configured;
};

export const buildApiUrl = (segment, path = "", query = "") =>
  `${resolveApiRoot()}/api/${segment}${path}${query}`;

export const isUsingLocalProxy = () => {
  const configured = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");
  return (
    typeof window !== "undefined" &&
    configured.includes("localhost:8080") &&
    window.location.origin !== configured
  );
};
